export const RNImageEditor = { cropImage: () => {} };
